import { ref } from 'vue';

const STORAGE_KEY = 'veyop.designTools.rulers';

function readInitial(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export const rulersVisible = ref(readInitial());

export function setRulersVisible(next: boolean): void {
  rulersVisible.value = next;
  try {
    localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
  } catch {
    // Ignore storage failures; current session still toggles.
  }
}

export function toggleRulers(): void {
  setRulersVisible(!rulersVisible.value);
}
